import React from 'react';
type propT = {
  strokeColor?: string;
  title?: string;
};
const Icon = (props: propT) => {
  return <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" preserveAspectRatio="xMidYMid meet">
      {props.title && <title>{props.title}</title>}
      <g clipPath="url(#clip0_3061_372)">
        <path d="M17.0549 8.35929L18.4537 17.5672L20.2077 15.8131L18.6291 5.37088L8.18686 3.79233L6.43285 5.54634L15.6407 6.94507L7.4922 15.0936L8.90641 16.5078L17.0549 8.35929Z" fill={props.strokeColor ? props.strokeColor : 'currentColor'} />
        <path d="M4.66377 17.922L6.07798 16.5078L7.4922 17.922L6.07798 19.3362L4.66377 17.922Z" fill={props.strokeColor ? props.strokeColor : 'currentColor'} />
      </g>
      <defs>
        <clipPath id="clip0_3061_372">
          <rect width="24" height="24" fill={props.strokeColor ? props.strokeColor : 'currentColor'} />
        </clipPath>
      </defs>
    </svg>;
};
export default Icon;